import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const InfoIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 10C12.5523 10 13 10.4477 13 11V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V11C11 10.4477 11.4477 10 12 10ZM12.0498 7C12.6021 7 13.0498 7.44772 13.0498 8V8.09961C13.0498 8.65113 12.6033 9.09853 12.0518 9.09961L11.9521 9.10059C11.6866 9.1011 11.4321 8.99521 11.2441 8.80762C11.0563 8.62012 10.9503 8.366 10.9502 8.10059V8C10.9502 7.44772 11.3979 7 11.9502 7H12.0498Z'
        fill={color}
      />
    </svg>
  )
})
